import { Message } from 'element-ui';
let messageInstance = null;
const resetMessage = (options) => {
  // messageInstance.close() 方法阻止多个弹层弹出  
  if(messageInstance) {
    messageInstance.close()
  }
  messageInstance = Message(options)
};
['error','success','info','warning'].forEach(type => {
  resetMessage[type] = options => {
    if(typeof options === 'string') {
      options = {
        message:options
      }
    }
    options.type = type
    return resetMessage(options)
  }
})
export const noRepeatMessage = resetMessage


// WEBPACK FOOTER //
// ./src/utils/resetMessage.js